import Api from './Api';
import {store} from "../store";

export default {

    getOrgId() {
        return store.getters['user/getOrgContext'] || store.getters['user/getOrgId'];
    },

    async getSamlMetadata() {
        return new Api().get('/auth/saml2/admin/api/v1/orgs/' + this.getOrgId() + '/metadata');
    },

    async createSamlMetadata(metadata) {
        return new Api().post('/auth/saml2/admin/api/v1/orgs/' + this.getOrgId() + '/metadata', metadata);
    },

    async deleteSamlMetadata() {
        return new Api().delete('/auth/saml2/admin/api/v1/orgs/' + this.getOrgId() + '/metadata');
    }
};
